<template>
  <div
    class="my-8 p-3 md:p-6 border-gray-300 bg-white border rounded-xl md:flex"
  >
    <div v-if="image" class="image w-full md:w-5/12">
      <div class="aspect-video w-full rounded-lg overflow-hidden bg-gray-100">
        <img
          class="object-cover w-full h-full"
          :src="image"
          :alt="title ? title : ''"
          loading="lazy"
          width="400"
          height="225"
        />
      </div>
    </div>
    <div
      class="w-full flex flex-col"
      :class="image ? 'md:pl-8 md:w-7/12 pt-5 md:pt-0' : ''"
    >
      <div v-if="title" class="text-h5 mb-2">
        {{ title }}
      </div>
      <div v-if="text" class="text-base mb-7" v-html="text" />
      <Button
        variant="outlined"
        class="p-2 w-full hover:bg-primary hover:text-white mt-auto"
        data-test-id="contact-us-button"
        @click="toggleDateRequestSidebar(route.name, 'magazine_banner')"
      >
        <span class="flex justify-center items-center">
          <PeopleIcon />
          {{ buttonLabel ? buttonLabel : $t('teamEvents.button.label') }}
          &gt;
        </span>
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import PeopleIcon from '~/assets/icons/people.svg?component'

const { toggleDateRequestSidebar } = useUiState()
const route = useRoute()

withDefaults(
  defineProps<{
    title?: string
    text?: string
    image?: string
    buttonLabel?: string
  }>(),
  {
    title: '',
    text: '',
    image: '',
    buttonLabel: '',
  }
)
</script>

<style lang="css" scoped>
@reference '~/assets/css/tailwind.css';
.image {
  position: relative;
  display: flex;
  line-height: 1;

  img {
    @apply rounded-lg;
    @apply w-full;
    margin: 0;
    object-fit: cover;
  }
}
</style>
